(ns splash.ui.lender-portal.components.nav-bar
  (:require
    ["@azure/msal-react" :as msal-react]
    ["react-router-dom" :refer [useHistory]]
    [splash.ui.lender-portal.components.mui :as mui]
    [splash.ui.lender-portal.components.theme :as theme]
    [splash.ui.lender-portal.datadog :as datadog]))

(def splash-logos
  {:logos {:yellow "https://wp.splashfinancial.com/wp-content/uploads/Splash_Logo_SplashYellow.svg"
           :black  "https://wp.splashfinancial.com/wp-content/uploads/Splash_Logo_Black.svg"
           :white  "https://wp.splashfinancial.com/wp-content/uploads/Splash_Logo_White.svg"}
   :icons {:yellow "https://wp.splashfinancial.com/wp-content/uploads/Splash_Logomark_SplashYellow.svg"
           :black  "https://wp.splashfinancial.com/wp-content/uploads/Splash_Logomark_Black.svg"
           :white  "https://wp.splashfinancial.com/wp-content/uploads/Splash_Logomark_White.svg"}})

(defn app->header
  []
  (let [useMsal                (msal-react/useMsal)
        instance               (. useMsal -instance)
        history                (useHistory)
        active-account         (.getActiveAccount instance)
        handle-logout-redirect (fn []
                                 (when (some? instance)
                                   (datadog/set-user-info {})
                                   (-> instance
                                     (.logoutRedirect {:account active-account}))))]
    [mui/theme-provider (mui/create-theme theme/navbar)
     [mui/app-bar {:id       "app-header"
                   :position :static
                   :sx       {:z-index 999}}
      [mui/container  {:maxWidth false}
       [mui/toolbar {:disableGutters true}
        [mui/button {:on-click (fn [] (.push history "/search"))}
         [:img {:id    "nav-logo"
                :src   (get-in splash-logos [:logos :yellow])
                :width 112}]]
        [mui/box {:sx {:flexGrow 1
                       :display  {:xs :none
                                  :md :flex}}}]
        [mui/box {:sx             {:flexGrow 0}
                  :display        :flex
                  :direction      :row
                  :justifyContent :space-around
                  :alignItems     :center}
         (when (some? active-account)
           [mui/button {:onClick handle-logout-redirect
                        :variant "contained"}
            "LOG OUT"])]]]]]))
